
import { Component, Vue, Prop } from 'vue-property-decorator'

/**
 * @prop value 联系记录列表
*/
@Component({})
export default class ContactTable extends Vue {
    @Prop({ required: true }) private value!: any[]
    private logDialog = false
    private content = ''


    private matchContactWay(data: any) {
        if (data.by_im && data.by_sms) {
            return 'IM联系、短信联系'
        }
        return data.by_im ? 'IM 联系' : data.by_sms ? '短息联系' : '不明确'
    }

    private showContent(content: string) {
        this.logDialog = true
        this.content = content
    }
}
